
export default () => ({
  isCollectionLoading: false,
  isOfficeLoading: false,
  collection: [],
  office: {
    title: null,
    subtitle: null,
    metaTitle: null,
    email: null,
    map: null,
    phones: [],
    departments: [],
    route: null
  }
})